import type { FlexProps } from "@qws-org/ui-kit";
import type { FC } from "react";

import type { Features as FeaturesData } from "~/core";

import { FeaturesColumn } from "./components/FeaturesColumn";
import { FeaturesRow } from "./components/FeaturesRow";

export type FeaturesProps = {
  data: FeaturesData;
} & FlexProps;

export const Features: FC<FeaturesProps> = (props) => {
  const { data } = props;

  return (
    <>
      {data.variant === "column" ? (
        <FeaturesRow {...props} />
      ) : (
        <FeaturesColumn {...props} />
      )}
    </>
  );
};
